/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { EmotionStrictHttpResponse } from '../../emotion-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmotionsHistoryResponse } from '../../models/emotions-history-response';
import { SupplierEmotionRequestModel } from '../../models/supplier-emotion-request-model';

export interface ConsumerSupplierEmotionPost$Params {
      body?: SupplierEmotionRequestModel
}

export function consumerSupplierEmotionPost(http: HttpClient, rootUrl: string, params?: ConsumerSupplierEmotionPost$Params, context?: HttpContext): Observable<EmotionStrictHttpResponse<Array<EmotionsHistoryResponse>>> {
  const rb = new RequestBuilder(rootUrl, consumerSupplierEmotionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as EmotionStrictHttpResponse<Array<EmotionsHistoryResponse>>;
    })
  );
}

consumerSupplierEmotionPost.PATH = '/Consumer/SupplierEmotion';
